<footer>
    <div class="footer-sec">
        <div class="container">
            <div class="footer-left">
                <div class="fot-logo">
                    <a> <img title="24ieye" alt="24ieye" src="assets/images/footlogo.png"></a>
                    <ul class="footer_social_ico">
                        <li><a href="https://www.instagram.com/24ieye/" target="_blank" rel="nofollow" data-toggle="tooltip" title="Instagram"><i class="fa fa-instagram" aria-hidden="true"></i></a>
                        </li>
                        <li><a href="https://www.facebook.com/24ieye-106833537987301" target="_blank" rel="nofollow" data-toggle="tooltip" title="facebook"><i class="fa fa-facebook" aria-hidden="true"></i></a>
                        </li>
                        <li><a href="https://twitter.com/24ieye" target="_blank" rel="nofollow" data-toggle="tooltip" title="twitter"><i class="fa fa-twitter" aria-hidden="true"></i></a>
                        </li>
                        <li><a href="https://www.linkedin.com/company/24ieye/" target="_blank" rel="nofollow" data-toggle="tooltip" title="linkedin"><i class="fa fa-linkedin" aria-hidden="true"></i></a>
                        </li></ul>
                </div>
            </div>
            <div class="footer_menu">	
                <h4>Sitemap</h4>
                <ul id="footer-right">
                    <li><a href="https://www.24ieye.com/" aria-current="page">Home</a></li>
                    <li><a href="https://www.24ieye.com/aboutus/">24ieye</a></li>
                    <li><a href="https://www.24ieye.com/resources/">Resources</a></li>
                    <li><a href="https://www.24ieye.com/contact/">Contact</a></li>
                </ul>	
            </div>


            <div class="footer_play">	
                <h4>Mobile App</h4>
                <a target="_blank" href="https://play.google.com/store/apps/details?id=com.twentyfourieye" class="an-store"><img  src="assets/images/android.png" alt="" class="alignnone size-full wp-image-54" width="300" height="89"></a>
                <a target="_blank" href="https://apps.apple.com/us/app/24ieye/id1556819142" class="ios-store"><img  src="assets/images/ios.png" alt="" class="alignnone size-full wp-image-55" width="300" height="89"></a>
            </div>

            <div class="footer-contact">	
                <div class="ft_addres"><h4>Contact Us</h4><p>Office 706-A, Floor 07 Jasmine Complex, Al Hadiqa St, Al Khuwair Muscat, Oman</p></div>	
                <ul class="footer_call">
                    <li class="ft_call"><a href="tel:968-71924777">+968-71924777</a></li>
                    <li class="ft_mail"><a href="mailto:info@24ieye.com">info@24ieye.com</a></li>
                </ul>		 
                <div class="copy"><p>© 2021- 24ieye. All Rights Reserved</p></div>	
            </div>
        </div>
    </div>
</footer>
